import {
  selectSelectorGenerator,
  writeSelectorGenerator,
} from '../../qa-hooks/typedSelectorHelpers';

const QaHooks = {};

const hooks = {
  emailInput: 'emailInput',
  useEmailCheckbox: 'useEmailCheckbox',
  usernameInput: 'usernameInput',
  passwordInput: 'passwordInput',
  submitButton: 'submitButton',
};

const Selectors = { ...selectSelectorGenerator(hooks), ...QaHooks };
const WriteSelectors = writeSelectorGenerator(hooks);

export { Selectors, WriteSelectors };
